import { Container, Title, Accordion } from "@mantine/core";
import classes from "./FAQ.module.scss";
import "./styles.scss";

export function FaqComponent() {
  return (
    <div className="section-pad">
      <Container size="sm" className={classes.wrapper}>
        <div className={classes.header}>
          <span className={classes.eyebrow}>Spørsmål & svar</span>
          <Title ta="center" className={classes.title}>
            Ofte stilte spørsmål
          </Title>
        </div>

        <Accordion variant="separated">
          <Accordion.Item className={classes.item} value="Hvorfor">
            <Accordion.Control>Hvorfor skaffe coach?</Accordion.Control>
            <Accordion.Panel>
              En coach sparer deg for årevis med egen research, prøving og
              feiling. Du får også motivasjon når det trengs som mest — særlig i
              startfasen, der den indre gnisten ofte svinger fra dag til dag.
              <br /> <br />
              Vi mennesker er dårlige til å se våre egne blindsoner. Da er det
              gull verdt å ha noen som ser deg utenfra, og som raskt kan avdekke
              hva som holder deg tilbake og hvor potensialet ligger.
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item className={classes.item} value="Skiller">
            <Accordion.Control>
              Hva skiller meg fra andre coacher?
            </Accordion.Control>
            <Accordion.Panel>
              Der de fleste coacher kun fokuserer på kalorier og trening, ser
              jeg på det store bildet. Et lavt kaloriinntak kan funke i starten,
              men over tid gir det ofte negative effekter på stoffskifte og
              hormoner — og gjør at vekten fort kommer tilbake.
              <br /> <br />
              Kroppen er et komplekst system der alt henger sammen. Ved å ta tak
              i helheten fra dag én blir transformasjonen mer stabil, varig og
              uanstrengt.
              <br /> <br />
              Hos meg får du nok høre mye du aldri har tenkt over før — men aldri
              et eneste råd uten god vitenskapelig forankring, som jeg ikke selv
              har testet flere ganger. Alt jeg ber om, er at du er åpen for ny
              kunnskap og klar for å lære noe som kan gjøre hverdagen merkbart
              bedre.
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item className={classes.item} value="Oppna">
            <Accordion.Control>Hva kan man forvente å oppnå?</Accordion.Control>
            <Accordion.Panel>
              I tillegg til fysiske endringer i kroppskomposisjon, fettprosent
              og muskelmasse, vil mange også oppleve andre
              positive effekter som:
              <ul>
                <li>Økt energi</li>
                <li>Bedre søvn</li>
                <li>Styrket immunsystem</li>
                <li>Mindre smerter/ubehag</li>
                <li>Bedre hud</li>
                <li>Bedre hår</li>
                <li>Bedre munnhelse</li>
                <li>Mindre stress og uro</li>
                <li>Bedre kognitiv funksjon</li>
                <li>Bedre psykisk helse</li>
              </ul>
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item className={classes.item} value="Enkelttime">
            <Accordion.Control>Hvem er coachingen for?</Accordion.Control>
            <Accordion.Panel>
              Coachingen er for alle som vil bli en bedre versjon av seg selv,
              uansett utgangspunkt. Programmet passer like bra for deg
              som aldri har vært på treningsstudio eller følgt noen som helst
              diett, til deg som vil optimalisere helse og livsstil til det
              maksimale.
              <br /> <br />
              Jeg har selv gått gjennom hele prosessen fra absolutt bunn med
              null kunnskap eller intensjoner om å leve et sunt liv, til å nå
              leve et liv der nesten alle komponenter i livet mitt er
              optimalisert til å være så bra som overhodet mulig. Etter å ha
              vært litt i overkant på begge sider av "sunnhetsspekteret", har
              jeg nå funnet en god balanse som fungerer utmerket for meg, noe
              som jeg også vil hjelpe andre med å finne.
            </Accordion.Panel>
          </Accordion.Item>

          <Accordion.Item className={classes.item} value="Andrespm">
            <Accordion.Control>Lurer du på noe?</Accordion.Control>
            <Accordion.Panel>
              Dersom det er noe du lurer på, enten om det er noe uklart, eller
              du bare har generelle spørsmål angående coachingen, så er det bare
              å sende meg en mail via kontaktskjema, så svarer jeg så fort jeg
              kan!
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Container>
    </div>
  );
}
